import { Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { LocalStorage } from "ngx-store";
import { Tab } from 'src/app/tabs/models/tab.model';
import * as _ from 'lodash';

@Injectable({
  providedIn: "root"
})

export class RoutingStateService {
  private history = [];
  @LocalStorage("tabs_core") navLinks: Tab[];
  applicableHomepage;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
        this.history.push({ url: urlAfterRedirects, dateTime: new Date() });
      });

      const user = JSON.parse(localStorage.getItem('user'));
      if (user && user.applicableHomepage && user.applicableHomepage.url){
        this.applicableHomepage = user.applicableHomepage.url;
      }
  }


  public getHistory(): string[] {
    return this.history;
  }

  public hasHistory(): boolean {
    return this.history && this.history.length > 0;
  }

  public getPreviousNonErrorUrl(): string {
    let i = 1;
    while (this.history[this.history.length - i].url.includes('error')) {
      i++
    }
    return this.history[this.history.length - i];
  }

  getTabIndex(url:string){
    return this.navLinks.findIndex(item => item.path === url);
  }

  public getPreviousUrlBeforeError(): string {

    let returnUrl;

    let historyReversed = _.cloneDeep(this.history).reverse();

    historyReversed.forEach((element, index) => {
      if (historyReversed[index+1] && !returnUrl){
        let diffDates = element.dateTime.getTime() - historyReversed[index+1].dateTime.getTime();
        let diffSeconds = Math.floor(diffDates / 1000 % 60);
        if (diffSeconds>1){
          returnUrl = historyReversed[index+1].url;
        }
      }
    });

    if (!returnUrl)
      returnUrl = this.redirectToHomepage;

    return returnUrl;
  }

  get redirectToHomepage(){
    let path = '/dashboard/page/vessel';

    if (this.applicableHomepage && this.applicableHomepage!='/home'){

      path = this.applicableHomepage;

      if (!path.startsWith("/")) {
        path += "/";
      }

    }

    return path;

  }

  validRoutesWhitelist(url: string) {
    return (url && (url.includes("home") || url.includes("notifications")  || url.includes("tasks") || url.includes("user-personal-management") || url.includes("403") || url.includes("404") || url.includes("500") || url.includes("401")));
  }

  routeIsValid(routerStateUrl: any) {
    const menuList = JSON.parse(sessionStorage.getItem("menu"));
    if (this.validRoutesWhitelist(routerStateUrl)) {
      return true;
    }
    // MenuService was not called yet. User is not logged in
    if (menuList === null) {
      return true;
    }
    let isValidRoute: boolean = false;
    if (menuList && menuList.length > 0 && routerStateUrl) {
      menuList.forEach((menu: any) => {
        if (routerStateUrl.includes(menu.url)) {
          isValidRoute = true;
          return;
        }
        if (menu.items && menu.items.length > 0) {
          menu.items.forEach((menuItem: any) => {
            if (routerStateUrl.includes(menuItem.url)) {
              isValidRoute = true;
              return;
            }
          });
        }
      });
    }
    return isValidRoute;
  }

  clearUnauthorizedTabs() {
    for (let i = 0; i < this.navLinks.length; i++) {
      if (!this.routeIsValid(this.navLinks[i].path) && this.navLinks[i].path === this.router.url) {
        this.router.navigate(["home"]);
      }
      if (!this.routeIsValid(this.navLinks[i].path)) {
        this.navLinks.splice(i, 1);
      }
    }
  }


}
